export default __webpack_public_path__ + "static/media/shopify.690824f3.svg";